import {useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {isAxiosError} from "axios";

export function useDeleteAllArchivedContacts(clientID: string | null, onSuccess: () => void) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const submit = async () => {
        setLoading(true);
        setError("");
        try {
            await platformAPI.delete("api/contacts", {params: {clientID}});
            onSuccess();
        } catch (e) {
            setError(isAxiosError(e) ? (e.response?.data?.error ?? "Failed to delete contacts") : "Failed to delete contacts");
        } finally {
            setLoading(false);
        }
    };

    return {submit, loading, error};
}
